import axios from "axios";
import { useTranslation } from "react-i18next";
import { env } from "../../env";

const WarningPopUp = ({customerId, visitTypeData, sendWarningPopUpDataFromChild}) => {
    const { t } = useTranslation();
   
    const hangleModalClose = (e) => {
        e.preventDefault();
        sendWarningPopUpDataFromChild('close');
    }
    const hangleSave = async (e, type) => {
        e.preventDefault();
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };
        
        await axios.post(baseUrl+`/api/Customer/EndCustomerVisit`, {
            "CustomerId" : customerId,
            "VisitId": visitTypeData.visitId,
            "TypeOfVisit": type === 'yes' ? visitTypeData.visitType : false,
            "TypeOfVisitId": visitTypeData.visitTypeId
        }, { headers })
        .then((response) => {
            sendWarningPopUpDataFromChild('complete');
            localStorage.removeItem("visit");
        }).catch((error) => {
            console.log(error);
        });
    }


    return (
        <div className="fixed z-50 overflow-y-auto top-0 w-full left-0 h-full">
            <div className="flex items-center justify-center min-height-100vh pt-4 px-4 pb-20 text-center sm:block sm:p-0 h-full">
                <div className="fixed inset-0 transition-opacity">
                    <div className="absolute inset-0 bg-gray-900 opacity-75" />
                </div>
                <span className="hidden sm:inline-block sm:align-middle sm:h-screen">&#8203;</span>
                <div className="inline-block align-center bg-white rounded-2xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle max-w-lg sm:w-full" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
                    <div className="bg-white py-4 px-4 sm:px-8 sm:py-8 space-y-3">
                        <div className="flex justify-between space-x-4 sm:space-x-0">
                            <div className="font-semibold text-sm sm:text-lg first-letter:capitalize">{ t('are you sure to exit customer profile')}?</div>
                            <div className="cursor-pointer" onClick={(e) => hangleModalClose(e)}>
                                <img src="../../../assets/icons/modal-cross.svg" alt="cross" />
                            </div>
                        </div>
                        <div className="text-gray-dark text-xs first-letter:capitalize">{ t('please take an action before you exit')}</div>
                        <div className="sm:flex sm:justify-between sm:items-center space-y-2 sm:space-y-0 sm:space-x-4">
                            <div className="flex justify-between space-x-2">
                                <button onClick={(e) => hangleSave(e, 'yes')} type="button" className="text-center px-2 sm:px-4 text-xs font-medium sm:text-base py-2 text-blue-normal bg-white border border-blue-normal rounded-lg tracking-wide first-letter:capitalize">{ t('save the record') }</button>
                                <button onClick={(e) => hangleSave(e, 'no')} type="button" className="text-center px-2 sm:px-4 text-xs font-medium sm:text-base py-2 text-gray-dark rounded-lg tracking-wide capitalize">{ t("don't save") }</button>
                            </div>
                            <button onClick={(e) => hangleModalClose(e)} type="button"  className="text-center px-2 sm:px-4 text-xs font-medium sm:text-base py-2 text-white bg-blue-normal border border-blue-normal rounded-lg tracking-wide capitalize w-full sm:w-auto">{ t('go back') }</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default WarningPopUp;